import { Link, useSearch } from '@tanstack/react-router'
import { Alert, AppLayout, Badge, Card, RequireSession } from 'vcode-commons-ui'
import BankIcon from '../components/BankIcon'
import { useBankAccounts } from '../lib/banking'

const primaryLink =
  'inline-block rounded-lg bg-neutral-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-neutral-800 dark:bg-neutral-100 dark:text-neutral-900 dark:hover:bg-white'

export default function AccountsPage() {
  return (
    <RequireSession>
      {(user) => (
        <AppLayout user={user}>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h1 className="text-2xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
              Mes comptes
            </h1>
            <Link to="/accounts/new" className={primaryLink}>
              Ajouter un compte
            </Link>
          </div>
          <CreatedNotice />
          <AccountList />
        </AppLayout>
      )}
    </RequireSession>
  )
}

function CreatedNotice() {
  const search = useSearch({ from: '/accounts' })
  if (search.created === undefined) {
    return null
  }

  return (
    <div className="mt-6">
      <Alert tone="success">
        Compte « {search.created} » cree.
        {search.pending === true &&
          ' La banque que vous avez ajoutee sera verifiee par un administrateur ; elle apparaitra dans la liste des banques une fois validee.'}
      </Alert>
    </div>
  )
}

function AccountList() {
  const accounts = useBankAccounts()

  if (accounts.isPending) {
    return <p className="mt-6 text-sm text-neutral-500">Chargement...</p>
  }

  if (accounts.isError) {
    return (
      <div className="mt-6">
        <Alert>{accounts.error.message}</Alert>
      </div>
    )
  }

  if (accounts.data.length === 0) {
    return (
      <div className="mt-6">
        <Card>
          <p className="text-sm text-neutral-600 dark:text-neutral-400">
            Aucun compte pour l'instant. Ajoutez votre premier compte : banque, libelle et IBAN suffisent.
          </p>
          <Link to="/accounts/new" className={`mt-4 ${primaryLink}`}>
            Ajouter un compte
          </Link>
        </Card>
      </div>
    )
  }

  return (
    <ul className="mt-6 grid gap-3 sm:grid-cols-2">
      {accounts.data.map((account) => (
        <li
          key={account.accountId}
          className="flex items-center gap-4 rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-900"
        >
          <BankIcon bank={account.bank} size="lg" />
          <div className="min-w-0 flex-1">
            <div className="truncate font-medium text-neutral-900 dark:text-neutral-100">{account.label}</div>
            <div className="truncate text-sm text-neutral-600 dark:text-neutral-400">{account.bank.name}</div>
            <div className="mt-1 font-mono text-xs text-neutral-500 dark:text-neutral-400">
              IBAN •••• {account.ibanLast4}
            </div>
          </div>
          {account.bank.status === 'pending' && <Badge tone="warn">Banque en attente</Badge>}
        </li>
      ))}
    </ul>
  )
}
